if (!customElements.get('page-header')) {
  class PageHeader extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('[data-section-type="page-header"]');
    }

    connectedCallback() {
      // Add any JavaScript functionality if needed
    }
  }

  customElements.define('page-header', PageHeader);
}
